import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface Clause {
  title: string;
  body: string;
}

export default function GiftCardTerms() {
  const { t } = useTranslation('giftCard');
  // Shows only the active language's clauses (no EN/CN mixing).
  const clauses = t('terms.clauses', { returnObjects: true }) as Clause[];

  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <Helmet>
        <title>{t('meta.titleTerms')}</title>
        <meta name="description" content={t('meta.descriptionTerms')} />
      </Helmet>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('terms.title')}</h1>
      <ol className="space-y-6">
        {clauses.map((c, i) => (
          <li key={c.title}>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">
              {i + 1}. {c.title}
            </h2>
            <p className="text-gray-700">{c.body}</p>
          </li>
        ))}
      </ol>
      <p className="mt-10 text-sm text-gray-500">
        {t('terms.questions')}
        <a href="mailto:hello@sayyoyo.com" className="text-primary underline">
          hello@sayyoyo.com
        </a>
      </p>
    </div>
  );
}
